import '@/scss/pages/city.scss'
import { useSidebarBottom } from '@/js/common/sidebar-bottom'

import header from '../layout/header'
import { useSlider } from '../common/slider'
import { initClarity } from '@/js/helpers/clarity'
import moveToLand from '@/js/section/home/move-to-land'
import config from '@/js/common/config.json'

document.addEventListener('DOMContentLoaded', function () {
  header()
  moveToLand()
  useSlider()
  initClarity('#main', config.city)
  useSidebarBottom()
})
